import React, {useEffect, useState} from 'react';

function CopyMe({data, icon, children}) {
    function copyText(entryText) {
        navigator.clipboard.writeText(entryText);
    }

    const [copied, setCopied] = useState(false)
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (copied) setCopied(false)
        }, 1000)

        return () => clearTimeout(timeout)
    }, [copied])
    return (
        <>
            <div className={'relative'}>
                <div className={`cursor-pointer ${copied ? 'text-green-500' : ''}`} onClick={() => {
                    if (data) {
                        copyText(data);
                        setCopied(true)
                    }

                }}>
                    {icon && <i className={'icon-copy p-1'}></i>}

                    {children}


                </div>

                {copied &&
                    <span
                        className="absolute bottom-6 end-3 bg-gray-100   text-xs font-medium me-2 px-2.5 py-0.5 rounded
                    dark:bg-gray-700 dark:text-gray-300">کپی شد</span>
                }
            </div>
        </>

    );
}

export default CopyMe;